define([
    "underscore",
    "backbone",
    "forms/payout/common_form"
], function(_, Backbone, CommonForm) {
    return CommonForm.extend({
        url: "/rest_payout/validate_bankwire_sticpay_form",

        validation: {
            mt4_account_no: {
                required: true,
                min: 10000
            },
            currency_abbr: {
                required: true
            },
            amount: {
                required: true,
                pattern: 'number'
            },
            last_name: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            first_name: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            bank_name:{
                required: true,
                // pattern: 'alphaDashSpacesCommasDots'
            },
            bank_account_holder:{
                required: true
            },
            bank_account:{
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
        }
    });
});
